export function coercerFirstValue<T>(value: unknown): T | undefined {
	if (Array.isArray(value)) {
		return value.length > 0 ? value[0] as T : undefined;
	}

	return value as T;
}

export const coercers = { firstValue: coercerFirstValue };
